import React from "react";

const Announcement = () => {
	return (
		<div className="announcement">
			<h3>⛈️ Driftproblem </h3>
			<p style={{ fontSize: "0.875rem" }}>
				Ordel har haft driftproblem under onsdagen som nu är åtgärdade. Under en
				kort period visades fel ledtrådar. Statistiken kommer att korrigeras i
				efterhand så att ingen förlorar sin vinstsvit.
			</p>
		</div>
	);
};

export default Announcement;
